import React from "react";
import EventGalleryUploader from "components/EventGalleryUploader";

export default function EventSettings() {
  return (
    <EventGalleryUploader
      heading="Event Photo Gallery"
      description="Add up to 100 photos for this event. Uploads run one by one with automatic retry so weak connections do not kill the whole batch."
      showEventMeta
    />
  );
}
